// @ts-strict-ignore
import React from 'react';

import { Box } from 'components/Box';
import { Divider } from 'components/Divider';
import { Image } from 'components/Image';
import { Link } from 'components/Link';
import { Body, H1, HeadingSmall } from 'components/Text';
import { gutterWidth } from 'theme';

export function NotFoundContent({
  searchText,
  searchUrl,
  homepageUrl,
  textOnly,
}: {
  searchText?: string;
  searchUrl?: string;
  homepageUrl?: string;
  textOnly?: boolean;
}) {
  return (
    <Box display={!textOnly && ['block', null, 'flex']} alignItems="center">
      <Box
        width={!textOnly && [1, null, 1 / 2]}
        pr={!textOnly && [0, null, gutterWidth]}
      >
        <HeadingSmall color="battleshipGrey">
          {'404: '}
          {getText('Page Not Found')}
        </HeadingSmall>

        <H1>
          {
            /* TRANSLATORS: 404 page title */
            getText(`Well, this isn't ideal...`)
          }
        </H1>

        <Body>
          {
            /* TRANSLATORS: 404 page copy */
            getText(`Sorry, we couldn't find the page you were looking for.
          The link you followed may be broken, or the page may have been removed.
          Try the following options:`)
          }
        </Body>

        <Box mt={(gutterWidth * 3) / 4}>
          <Link href={searchUrl || `/jobs`}>
            <Box display="flex" alignItems="center">
              <Box transform="translateY(3px)">
                <Image
                  src="/static/images/magifying-glass.png"
                  alt="magnifying glass"
                  width={24}
                />
              </Box>
              <Box ml={24}>
                {searchText ||
                  (searchUrl
                    ? getText('Search the site')
                    : getText('Search jobs'))}
              </Box>
            </Box>
          </Link>

          <Divider light my={gutterWidth / 2} />

          <Link href={homepageUrl || '/'}>
            <Box display="flex" alignItems="center">
              <Box transform="translateY(3px)">
                <Image
                  src="/static/images/logo-mark.png"
                  alt="magnifying glass"
                  width={24}
                />
              </Box>
              <Box ml={24}>{getText('Go to the homepage')}</Box>
            </Box>
          </Link>
        </Box>
      </Box>

      {!textOnly && (
        <Box
          position="relative"
          height="100%"
          width={[1, null, 1 / 2]}
          mt={[gutterWidth, null, 0]}
        >
          <Image src="/static/images/not-found.svg" alt="Illustration" />
        </Box>
      )}
    </Box>
  );
}
